import { render, staticRenderFns } from "./ArchiveUsers.vue?vue&type=template&id=f782581e&"
import script from "./ArchiveUsers.vue?vue&type=script&lang=js&"
export * from "./ArchiveUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ArchiveUsers.vue"
export default component.exports